import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsultationHistoryService {

  constructor(private http: HttpClient) { }
  GetConsultationHistory(){
    return this.http.get(`${environment.API_Base_URL}`+`Consultation/Self/GetConsHistoryById`)
  }
  Get_diagnosisbyid(id) {
    return this.http.get(`${environment.API_Base_URL}` + `Consult_diag/GetById_Consult_diag?Conslt_id=${id}`)
  }
  Get_drugpresby_id(id) {
    return this.http.get(`${environment.API_Base_URL}` + `Drug_Prescription/GetById_Drug_Prescription?Cons_Id=${id}`)
  }
  get_labtestbyid(id){
    return this.http.get(`${environment.API_Base_URL}` + `Consultation/GetAllLabtestbyId?CON_Id=${id}`)
  }
  Get_dietbyid(id) {
    return this.http.get(`${environment.API_Base_URL}` + `DietPlan/GetDietPlanById?Id=${id}`)
  }
  Get_referralby_id(data){
    return this.http.get(`${environment.API_Base_URL}` + `Referrals/GetReferralsByCON_Id?CON_Id=${data}`)
  }
  Get_revistby_id(data){
    return this.http.get(`${environment.API_Base_URL}` + `ReVisit/GetReVisitByCON_Id?CON_Id=${data}`)
  }
  Get_documentdetail_patientid(id) {
    return this.http.get(`${environment.API_Base_URL}` + `PatientDocument/GetPatientDocumentByPatientId/` + id);
  }
  Get_Consultation_id(consult_id) {
    return this.http.get(`${environment.API_Base_URL}` + `Consultation/Admin/GetConsultationById?CON_Id=${consult_id}`)
  }
}
